var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExtrusionOpAnterior(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.72745 26.5H24.4524L29.4346 15.8768L21.5504 5.5H2.72705L2.72745 26.5ZM4.72741 24.5L4.72709 7.5H20.5582L27.11 16.1232L23.1813 24.5H4.72741Z",
    fill: "#647B8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.27667 25.9526C6.52668 26.0699 6.82441 25.9622 6.94167 25.7122L11.2622 16.4999H28.2717C28.5478 16.4999 28.7717 16.2761 28.7717 15.9999C28.7717 15.7238 28.5478 15.4999 28.2717 15.4999H11.1925L4.12458 6.19743C3.95752 5.97755 3.64385 5.93473 3.42397 6.10179C3.20409 6.26885 3.16128 6.58253 3.32834 6.8024L10.3633 16.0615L6.03629 25.2876C5.91904 25.5376 6.02666 25.8353 6.27667 25.9526Z",
    fill: "#647B8F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtrusionOpAnterior);
export default __webpack_public_path__ + "static/media/extrusion-op-anterior.826c58b0.svg";
export { ForwardRef as ReactComponent };